






























































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import BotaoDeDrawer from '@/components/ui/BotaoDeDrawer.vue'
import { FindLojaUseCase } from '@/usecases'
import FiltroAvancadoDeDashboard, { FiltrosAvancadosDoDashboard } from '@/views/application/dashboards/FiltroAvancadoDeDashboard.vue'
import { Periodo } from '@/shareds/date/date-utils'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import SeletorDePeriodo from './SeletorDePeriodo.vue'
import moment from 'moment'
import IconesDaToolbarPadroes from '@/components/layout/IconesDaToolbarPadroes.vue'

@Component({
	components: {
		BotaoDeDrawer,
		FiltroAvancadoDeDashboard,
		SeletorDeLojas,
		SeletorDePeriodo,
		IconesDaToolbarPadroes,
	},
})
export default class ToolbarDoDashboardInicial extends Vue {
	@Prop({ type: String, default: '' }) titulo!: string
	@Ref() dialogoDeFiltros!: FiltroAvancadoDeDashboard

	mostra = false

	findLojaUseCase = new FindLojaUseCase()

	remove(id: string) {
		if (!this.lojas) return
		const indiceDaLoja = this.lojas.indexOf(id)
		this.lojas.splice(indiceDaLoja, 1)
	}

	formataNomeDaLojaChip(nome: string) {
		const nomeSplitado = nome.match(/[a-zA-Z]{4,}/g)
		if (!nomeSplitado) return nome
		return nomeSplitado.map(nome => nome.substr(0, 4)).join('.')
	}

	aplicarFiltro(filtro: FiltrosAvancadosDoDashboard) {
		this.pdvs = filtro.pdvs.length
			? filtro.pdvs
			: null
	}

	get periodo() {
		const periodoDaQuery = this.$route.query.d
		if (typeof periodoDaQuery === 'string' && moment(periodoDaQuery).isValid()) {
			return [periodoDaQuery, null]
		}
		if (Array.isArray(periodoDaQuery) && periodoDaQuery.length === 1 ) {
			return [periodoDaQuery[0] as string, null]
		}
		return (periodoDaQuery as Periodo) || null
	}

	set periodo(periodo: Periodo | null) {
		this.$router
			.replace({
				name: this.$route.name as string,
				query: {
					...this.$route.query,
					d: Array.isArray(periodo)
						? periodo.filter(periodo => !!periodo)
						: periodo,
				},
			})
	}

	get lojas() {
		if (typeof this.$route.query.l === 'string') return [this.$route.query.l]
		return (this.$route.query.l as string[]) || null
	}

	set lojas(lojas: string[] | null) {
		this.$router
			.replace({
				name: this.$route.name as string,
				query: {
					...this.$route.query,
					l: lojas,
				},
			})
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			.catch(() => {})
	}

	get pdvs() {
		return (this.$route.query.p as string[]) || null
	}

	set pdvs(pdvs: string[] | null) {
		this.$router
			.replace({
				name: this.$route.name as string,
				query: {
					...this.$route.query,
					p: pdvs,
				},
			})
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			.catch(() => {})
	}

	get exibirGraficoMetasPorLoja() {
		return this.lojas && this.lojas.length > 0
	}
}
